import { Table } from 'dexie';
import { OrderSearchResponse, OrderSearchResult } from '@/api/models';
import db, { Database } from '@/db';

export type TABLE_TYPE = Table<OrderSearchResponse, string>;

export const TABLE = 'ordersCache';
const SCHEMA = '';
const OFFLINE_CACHE_KEY = 'offline';

class OrdersDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  getOfflineCache(): Promise<OrderSearchResponse | undefined> {
    return this.db[TABLE].get(OFFLINE_CACHE_KEY);
  }

  async appendMissingOrders(orders: OrderSearchResult[]): Promise<void> {
    await this.db.transaction('rw', this.db[TABLE], async () => {
      const cache = await this.getOfflineCache();
      const results = [...(cache?.results ?? [])];
      const ids = new Set(results.map((order) => order.orderMstrId));
      for (const order of orders) {
        if (ids.has(order.orderMstrId)) continue;
        ids.add(order.orderMstrId);
        results.push(order);
      }
      await this.db[TABLE].put({ ...cache, results, searchRowCount: results.length, readyToShipOrderCount: cache?.readyToShipOrderCount ?? null }, OFFLINE_CACHE_KEY);
    });
  }

  async replaceOfflineCache(response: OrderSearchResponse, lastOrdersSyncDate: string, previousIds?: number[]): Promise<void> {
    await this.db.transaction('rw', this.db[TABLE], this.db.appSettings, async () => {
      let snapshot = response;
      if (previousIds) {
        const previous = new Set(previousIds);
        const current = await this.getOfflineCache();
        const ids = new Set(response.results.map((order) => order.orderMstrId));
        const additions = (current?.results ?? []).filter((order) => !previous.has(order.orderMstrId) && !ids.has(order.orderMstrId));
        snapshot = { ...response, results: [...response.results, ...additions], searchRowCount: response.searchRowCount + additions.length };
      }
      await this.db[TABLE].put(snapshot, OFFLINE_CACHE_KEY);
      await this.db.appSettings.put({ key: 'lastOrdersSyncDate', value: lastOrdersSyncDate });
    });
  }
}

export const OrdersDB = new OrdersDatabase(db);
